import Vue from "vue";
import Vuex from "vuex";
import cart from "./modules/cart";
import products from "./modules/products";
import orders from "./modules/orders";
import discounts from "./modules/discounts";
import settings from "./modules/settings";
import createLogger from "@/plugins/logger";
import reports from "./modules/reports";
import poolFormulas from "./modules/poolFormulas";
import poolOrders from "./modules/poolOrders";
import stocks from "./modules/stocks";
import payments from "./modules/payment";
import stockDetails from "./modules/stockDetails";
import productCategory from "./modules/productCategory";
import priceIncrease from "./modules/priceIncrease";
import stockGroups from "./modules/stockGroups";
import insurances from "./modules/insurances";
import formulaMultipliers from "./modules/formulaMultipliers";
import mpProducts from "./modules/mpProducts";
import mpDiscounts from "./modules/mpDiscounts";
import categories from "./modules/categories";
import carousels from "./modules/carousels";
import partnerBanks from "./modules/partnerBanks";
import richOrders from "./modules/richOrders";
import campaignCommissions from "./modules/campaignCommissions";
import appSettings from "./modules/appSettings";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';
export const mutationTypes = {
  ADD_PENDING: 'ADD_PENDING',
  REMOVE_PENDING: 'REMOVE_PENDING',
};

export default new Vuex.Store({
  modules: {
    cart,
    products,
    orders,
    payments,
    settings,
    reports,
    poolFormulas,
    poolOrders,
    discounts,
    stocks,
    stockDetails,
    productCategory,
    priceIncrease,
    stockGroups,
    insurances,
    formulaMultipliers,
    mpProducts,
    mpDiscounts,
    categories,
    partnerBanks,
    richOrders,
    appSettings,
    campaignCommissions,
    carousels
  },
  state: {
    layout: 'app-layout',
    pendings: [],
    progress: false,
    dialog: false,
    message: null,
  },
  getters: {
    layout(state) {
      return state.layout;
    },
    pendings(state) {
      return state.pendings;
    },
  },
  mutations: {
    SET_LAYOUT(state, payload) {
      state.layout = payload;
    },
    [mutationTypes.ADD_PENDING](state, pending) {
      state.progress = true;
      state.pendings.push(pending);
    },
    [mutationTypes.REMOVE_PENDING](state, pending) {
      state.progress = false;
      state.pendings.splice(state.pendings.indexOf(pending), 1);
    },
  },
  strict: false, //debug
  plugins: debug ? [createLogger()] : [],
});
